import { render, staticRenderFns } from "./TypologyShow.vue?vue&type=template&id=308492d5&scoped=true&"
import script from "./TypologyShow.vue?vue&type=script&lang=js&"
export * from "./TypologyShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308492d5",
  null
  
)

export default component.exports